module.exports = __webpack_public_path__ + "img/report.2da6f690.svg";